export const MovieData = [
  {
    id: 123,
    movie_detail: {
      title: "The Woman King",
      length: "126Min",
      img: "https://image.cineplexbd.com/movies/166253662057972.webp",
      video: "https://www.youtube.com/watch?v=3RDaPV_rJ1Y",
      rating: "0.0",
      category: "2D",
      actor: "Hero Fiennes Tiffin,Viola Davis",
      genre: "Action,Drama,Adventure",
      release: "07-10-2022",
      language: "English",
    },
    show_time: [
      {
        date: "12th , October 2022",
        date_name: "Wednesday ",
        slot: [
          {
            time: "12:40 PM",
            hall: 1,
            hall_id: 2,
            hall_type: "Regular",
          },
          {
            time: "05:10 PM",
            hall: 1,
            hall_id: 2,
            hall_type: "Regular",
          },
          {
            time: "07:00 PM",
            hall: 3,
            hall_id: 5,
            hall_type: "VIP",
          },
        ],
      },
      {
        date: "13th , October 2022",
        date_name: "Thursday ",
        slot: [
          {
            time: "12:40 PM",
            hall: 1,
            hall_id: 2,
            hall_type: "Regular",
          },
          {
            time: "05:10 PM",
            hall: 1,
            hall_id: 2,
            hall_type: "Regular",
          },
          {
            time: "07:00 PM",
            hall: 3,
            hall_id: 5,
            hall_type: "VIP",
          },
        ],
      },
    ],
  },
  {
    id: 125,
    movie_detail: {
      title: "Operation Sundarbans (2D)",
      length: "142 Min",
      img: "https://image.cineplexbd.com/movies/166377073453348.webp",
      video: null,
      rating: "0.0",
      category: "2D",
      actor: "Siam Ahmed,Riaz, Roshan, Nusraat Faria",
      genre: "Action,Thriller",
      release: "23-09-2022",
      language: "Bangla",
    },
    show_time: [
      {
        date: "12th , October 2022",
        date_name: "Wednesday ",
        slot: [
          {
            time: "01:40 PM",
            hall: 2,
            hall_id: 6,
            hall_type: "Premium",
          },
          {
            time: "04:35 PM",
            hall: 2,
            hall_id: 6,
            hall_type: "Premium",
          },
          {
            time: "07:30 PM",
            hall: 2,
            hall_id: 6,
            hall_type: "Premium",
          },
        ],
      },
      {
        date: "15th , October 2022",
        date_name: "Friday ",
        slot: [
          {
            time: "01:40 PM",
            hall: 2,
            hall_id: 6,
            hall_type: "Premium",
          },
          {
            time: "04:35 PM",
            hall: 2,
            hall_id: 6,
            hall_type: "Premium",
          },
          {
            time: "07:30 PM",
            hall: 2,
            hall_id: 6,
            hall_type: "Premium",
          },
          {
            time: "09:30 PM",
            hall: 2,
            hall_id: 6,
            hall_type: "Premium",
          },
        ],
      },
      {
        date: "18th , October 2022",
        date_name: "Monday ",
        slot: [
          {
            time: "01:40 PM",
            hall: 2,
            hall_id: 6,
            hall_type: "Premium",
          },
          {
            time: "04:35 PM",
            hall: 2,
            hall_id: 6,
            hall_type: "Premium",
          },
          {
            time: "07:30 PM",
            hall: 2,
            hall_id: 6,
            hall_type: "Premium",
          },
          {
            time: "09:30 PM",
            hall: 2,
            hall_id: 6,
            hall_type: "Premium",
          },
          {
            time: "10:30 PM",
            hall: 2,
            hall_id: 6,
            hall_type: "Premium",
          },
        ],
      },
      {
        date: "13th , October 2022",
        date_name: "Thursday ",
        slot: [
          {
            time: "10:45 AM",
            hall: 2,
            hall_id: 6,
            hall_type: "Premium",
          },
          {
            time: "01:40 PM",
            hall: 2,
            hall_id: 6,
            hall_type: "Premium",
          },
          {
            time: "04:35 PM",
            hall: 2,
            hall_id: 6,
            hall_type: "Premium",
          },
          {
            time: "07:30 PM",
            hall: 2,
            hall_id: 6,
            hall_type: "Premium",
          },
        ],
      },
    ],
  },
  {
    id: 104,
    movie_detail: {
      title: "Poran (2D)",
      length: "2h 00min",
      img: "https://image.cineplexbd.com/movies/165720319543116.webp",
      video: null,
      rating: "0.0",
      category: "2D",
      actor: "Yash Rohan",
      genre: "Bangla, Action",
      release: "10-07-2022",
      language: "Bangla",
    },
    show_time: [
      {
        date: "8th , October 2022",
        date_name: "sunday ",
        slot: [
          {
            time: "01:50 PM",
            hall: 1,
            hall_id: 3,
            hall_type: "Regular",
          },
          {
            time: "07:20 PM",
            hall: 1,
            hall_id: 3,
            hall_type: "Regular",
          },
        ],
      },
      {
        date: "13th , October 2022",
        date_name: "Thursday ",
        slot: [
          {
            time: "01:50 PM",
            hall: 1,
            hall_id: 3,
            hall_type: "Regular",
          },
          {
            time: "07:20 PM",
            hall: 1,
            hall_id: 3,
            hall_type: "Regular",
          },
        ],
      },
      {
        date: "12th , October 2022",
        date_name: "Wednesday ",
        slot: [
          {
            time: "01:50 PM",
            hall: 1,
            hall_id: 3,
            hall_type: "Regular",
          },
          {
            time: "07:20 PM",
            hall: 1,
            hall_id: 3,
            hall_type: "Regular",
          },
        ],
      },
    ],
  },
  {
    id: 129,
    movie_detail: {
      title: "Hridhita",
      length: "133Min",
      img: "https://image.cineplexbd.com/movies/166505778256642.webp",
      video: "https://www.youtube.com/watch?v=pLSClWKvRK8",
      rating: "0.0",
      category: "2D",
      actor: "Puja Chery | ABM Sumon | Anisul Hoq",
      genre: "Drama",
      release: "07-10-2022",
      language: "Bangla",
    },
    show_time: [
      {
        date: "12th , October 2022",
        date_name: "Wednesday ",
        slot: [
          {
            time: "02:00 PM",
            hall: 1,
            hall_id: 1,
            hall_type: "Regular",
          },
          {
            time: "07:15 PM",
            hall: 1,
            hall_id: 1,
            hall_type: "Regular",
          },
        ],
      },
      {
        date: "13th , October 2022",
        date_name: "Thursday ",
        slot: [
          {
            time: "02:00 PM",
            hall: 1,
            hall_id: 1,
            hall_type: "Regular",
          },
          {
            time: "07:15 PM",
            hall: 1,
            hall_id: 1,
            hall_type: "Regular",
          },
        ],
      },
    ],
  },
  {
    id: 112,
    movie_detail: {
      title: "Avatar",
      length: "2h 42m",
      img: "https://image.cineplexbd.com/movies/166375781129348.webp",
      video: null,
      rating: "0.0",
      category: "3D",
      actor: "Sam Worthington",
      genre: "English",
      release: "23-09-2022",
      language: "English",
    },
    show_time: [
      {
        date: "12th , October 2022",
        date_name: "Wednesday ",
        slot: [
          {
            time: "03:00 PM",
            hall: 3,
            hall_id: 5,
            hall_type: "VIP",
          },
        ],
      },
      {
        date: "13th , October 2022",
        date_name: "Thursday ",
        slot: [
          {
            time: "11:30 AM",
            hall: 3,
            hall_id: 5,
            hall_type: "VIP",
          },
          {
            time: "03:00 PM",
            hall: 3,
            hall_id: 5,
            hall_type: "VIP",
          },
        ],
      },
    ],
  },
  {
    id: 127,
    movie_detail: {
      title: "The Free Fall",
      length: "82 Min",
      img: "https://image.cineplexbd.com/movies/166401628522826.webp",
      video: null,
      rating: "0.0",
      category: "2D",
      actor: "Andrea Londo",
      genre: "Drama,Thriller,Horror",
      release: "07-10-2022",
      language: "English",
    },
    show_time: [
      {
        date: "12th , October 2022",
        date_name: "Wednesday ",
        slot: [
          {
            time: "03:20 PM",
            hall: 1,
            hall_id: 2,
            hall_type: "Regular",
          },
          {
            time: "07:45 PM",
            hall: 1,
            hall_id: 2,
            hall_type: "Regular",
          },
        ],
      },
      {
        date: "13th , October 2022",
        date_name: "Thursday ",
        slot: [
          {
            time: "10:50 AM",
            hall: 1,
            hall_id: 2,
            hall_type: "Regular",
          },
          {
            time: "03:20 PM",
            hall: 1,
            hall_id: 2,
            hall_type: "Regular",
          },
          {
            time: "07:45 PM",
            hall: 1,
            hall_id: 2,
            hall_type: "Regular",
          },
        ],
      },
    ],
  },
  {
    id: 106,
    movie_detail: {
      title: "Hawa",
      length: "130Min",
      img: "https://image.cineplexbd.com/movies/165820878570654.webp",
      video: "https://www.youtube.com/watch?v=yhOIhko8VQ4",
      rating: "0.0",
      category: "2D",
      actor:
        "Chanchal Chowdhury,Nazifa Tushi,Sariful Islam Razz,Nasir Uddin Khan",
      genre: "Drama",
      release: "29-07-2022",
      language: "Bangla",
    },
    show_time: [
      {
        date: "12th , October 2022",
        date_name: "Wednesday ",
        slot: [
          {
            time: "04:40 PM",
            hall: 1,
            hall_id: 3,
            hall_type: "Regular",
          },
        ],
      },
      {
        date: "13th , October 2022",
        date_name: "Thursday ",
        slot: [
          {
            time: "11:00 AM",
            hall: 1,
            hall_id: 3,
            hall_type: "Regular",
          },
          {
            time: "04:40 PM",
            hall: 1,
            hall_id: 3,
            hall_type: "Regular",
          },
        ],
      },
    ],
  },
  {
    id: 128,
    movie_detail: {
      title: "Jao Pakhi Bolo Tare",
      length: "160",
      img: "https://image.cineplexbd.com/movies/166505740942892.webp",
      video: "https://www.youtube.com/watch?v=HU-vlC0xy6c",
      rating: "0.0",
      category: "2D",
      actor: "Ador Azad | Mahiya Mahi | Shipan",
      genre: "Drama",
      release: "07-10-2022",
      language: "Bangla",
    },
    show_time: [
      {
        date: "12th , October 2022",
        date_name: "Wednesday ",
        slot: [
          {
            time: "04:45 PM",
            hall: 1,
            hall_id: 1,
            hall_type: "Regular",
          },
        ],
      },
      {
        date: "13th , October 2022",
        date_name: "Thursday ",
        slot: [
          {
            time: "11:15 AM",
            hall: 1,
            hall_id: 1,
            hall_type: "Regular",
          },
          {
            time: "04:45 PM",
            hall: 1,
            hall_id: 1,
            hall_type: "Regular",
          },
        ],
      },
    ],
  },
  {
    id: 173,
    movie_detail: {
      title: "What's Love Got to Do with It",
      length: "108 Min",
      img: "https://image.cineplexbd.com/movies/167333167970037.webp",
      video: "https://www.youtube.com/watch?v=0LqOp2MNwao",
      rating: "0.0",
      category: "2D",
      actor: "Emma Thompson, Lily James",
      genre: "Romantic,Comedy",
      release: "03-03-2023",
      language: "English",
    },
    show_time: [
      {
        date: "4th , March 2023",
        date_name: "Saturday ",
        slot: [
          {
            time: "11:00 AM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
          {
            time: "03:10 PM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
          {
            time: "07:30 PM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
        ],
      },
      {
        date: "5th , March 2023",
        date_name: "Sunday ",
        slot: [
          {
            time: "11:00 AM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
          {
            time: "03:10 PM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
          {
            time: "07:30 PM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
        ],
      },
      {
        date: "7th , March 2023",
        date_name: "Tuesday ",
        slot: [
          {
            time: "11:00 AM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
          {
            time: "03:10 PM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
          {
            time: "07:30 PM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
        ],
      },
      {
        date: "8th , March 2023",
        date_name: "Wednesday ",
        slot: [
          {
            time: "11:00 AM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
          {
            time: "03:10 PM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
          {
            time: "07:30 PM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
        ],
      },
      {
        date: "9th , March 2023",
        date_name: "Thursday ",
        slot: [
          {
            time: "11:00 AM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
          {
            time: "03:10 PM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
          {
            time: "07:30 PM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
        ],
      },
    ],
  },
  {
    id: 182,
    movie_detail: {
      title: "Creed 3 (2D)",
      length: "2h 00min",
      img: "https://image.cineplexbd.com/movies/167766966258469.webp",
      video: null,
      rating: "0.0",
      category: "2D",
      actor: "Michael B. Jordan",
      genre: "English",
      release: "03-03-2023",
      language: "English",
    },
    show_time: [
      {
        date: "4th , March 2023",
        date_name: "Saturday ",
        slot: [
          {
            time: "11:15 AM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
          {
            time: "03:30 PM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
          {
            time: "07:45 PM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
        ],
      },
      {
        date: "5th , March 2023",
        date_name: "Sunday ",
        slot: [
          {
            time: "11:15 AM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
          {
            time: "03:30 PM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
          {
            time: "07:45 PM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
        ],
      },
      {
        date: "7th , March 2023",
        date_name: "Tuesday ",
        slot: [
          {
            time: "11:15 AM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
          {
            time: "03:30 PM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
          {
            time: "07:45 PM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
        ],
      },
      {
        date: "8th , March 2023",
        date_name: "Wednesday ",
        slot: [
          {
            time: "11:15 AM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
          {
            time: "03:30 PM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
          {
            time: "07:45 PM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
        ],
      },
      {
        date: "9th , March 2023",
        date_name: "Thursday ",
        slot: [
          {
            time: "11:15 AM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
          {
            time: "03:30 PM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
          {
            time: "07:45 PM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
        ],
      },
    ],
  },
  {
    id: 139,
    movie_detail: {
      title: "Ant-Man and the Wasp: Quantumania (3D)",
      length: "2h 05m",
      img: "https://image.cineplexbd.com/movies/166824912850887.webp",
      video: "https://www.youtube.com/watch?v=ZlNFpri-Y40",
      rating: "0.0",
      category: "3D",
      actor: "Paul Rudd, Evangeline Lilly ,Jonathan Majors",
      genre: "Action,Adventure,Comedy",
      release: "17-02-2023",
      language: "English",
    },
    show_time: [
      {
        date: "4th , March 2023",
        date_name: "Saturday ",
        slot: [
          {
            time: "11:30 AM",
            hall: 2,
            hall_id: 18,
            hall_type: "Premium",
          },
          {
            time: "02:10 PM",
            hall: 2,
            hall_id: 18,
            hall_type: "Premium",
          },
          {
            time: "04:45 PM",
            hall: 2,
            hall_id: 18,
            hall_type: "Premium",
          },
          {
            time: "07:15 PM",
            hall: 2,
            hall_id: 18,
            hall_type: "Premium",
          },
        ],
      },
      {
        date: "5th , March 2023",
        date_name: "Sunday ",
        slot: [
          {
            time: "11:30 AM",
            hall: 2,
            hall_id: 18,
            hall_type: "Premium",
          },
          {
            time: "02:10 PM",
            hall: 2,
            hall_id: 18,
            hall_type: "Premium",
          },
          {
            time: "04:45 PM",
            hall: 2,
            hall_id: 18,
            hall_type: "Premium",
          },
          {
            time: "07:15 PM",
            hall: 2,
            hall_id: 18,
            hall_type: "Premium",
          },
        ],
      },
      {
        date: "7th , March 2023",
        date_name: "Tuesday ",
        slot: [
          {
            time: "11:30 AM",
            hall: 2,
            hall_id: 18,
            hall_type: "Premium",
          },
          {
            time: "02:10 PM",
            hall: 2,
            hall_id: 18,
            hall_type: "Premium",
          },
          {
            time: "04:45 PM",
            hall: 2,
            hall_id: 18,
            hall_type: "Premium",
          },
          {
            time: "07:15 PM",
            hall: 2,
            hall_id: 18,
            hall_type: "Premium",
          },
        ],
      },
      {
        date: "8th , March 2023",
        date_name: "Wednesday ",
        slot: [
          {
            time: "11:30 AM",
            hall: 2,
            hall_id: 18,
            hall_type: "Premium",
          },
          {
            time: "02:10 PM",
            hall: 2,
            hall_id: 18,
            hall_type: "Premium",
          },
          {
            time: "04:45 PM",
            hall: 2,
            hall_id: 18,
            hall_type: "Premium",
          },
          {
            time: "07:15 PM",
            hall: 2,
            hall_id: 18,
            hall_type: "Premium",
          },
        ],
      },
      {
        date: "9th , March 2023",
        date_name: "Thursday ",
        slot: [
          {
            time: "11:30 AM",
            hall: 2,
            hall_id: 18,
            hall_type: "Premium",
          },
          {
            time: "02:10 PM",
            hall: 2,
            hall_id: 18,
            hall_type: "Premium",
          },
          {
            time: "04:45 PM",
            hall: 2,
            hall_id: 18,
            hall_type: "Premium",
          },
          {
            time: "07:15 PM",
            hall: 2,
            hall_id: 18,
            hall_type: "Premium",
          },
        ],
      },
    ],
  },
  {
    id: 138,
    movie_detail: {
      title: "Sword Art Online: Progressive - Aria of a Starless Night",
      length: "1h 48m",
      img: "https://image.cineplexbd.com/movies/167766883087376.webp",
      video: null,
      rating: "0.0",
      category: "2D",
      actor: null,
      genre: "English",
      release: "14-04-2023",
      language: "English",
    },
    show_time: [
      {
        date: "4th , March 2023",
        date_name: "Saturday ",
        slot: [
          {
            time: "01:10 PM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
          {
            time: "05:25 PM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
        ],
      },
      {
        date: "5th , March 2023",
        date_name: "Sunday ",
        slot: [
          {
            time: "01:10 PM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
          {
            time: "05:25 PM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
        ],
      },
      {
        date: "7th , March 2023",
        date_name: "Tuesday ",
        slot: [
          {
            time: "01:10 PM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
          {
            time: "05:25 PM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
        ],
      },
      {
        date: "8th , March 2023",
        date_name: "Wednesday ",
        slot: [
          {
            time: "01:10 PM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
          {
            time: "05:25 PM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
        ],
      },
      {
        date: "9th , March 2023",
        date_name: "Thursday ",
        slot: [
          {
            time: "01:10 PM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
          {
            time: "05:25 PM",
            hall: 2,
            hall_id: 19,
            hall_type: "Premium",
          },
        ],
      },
    ],
  },
  {
    id: 183,
    movie_detail: {
      title: "JK 1971 (2D)",
      length: "90 Min",
      img: "https://image.cineplexbd.com/movies/167766991357674.webp",
      video: null,
      rating: "0.0",
      category: "2D",
      actor: null,
      genre: "Bangla",
      release: "03-03-2023",
      language: "Bangla",
    },
    show_time: [
      {
        date: "4th , March 2023",
        date_name: "Saturday ",
        slot: [
          {
            time: "01:40 PM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
          {
            time: "05:50 PM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
        ],
      },
      {
        date: "5th , March 2023",
        date_name: "Sunday ",
        slot: [
          {
            time: "01:40 PM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
          {
            time: "05:50 PM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
        ],
      },
      {
        date: "7th , March 2023",
        date_name: "Tuesday ",
        slot: [
          {
            time: "01:40 PM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
          {
            time: "05:50 PM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
        ],
      },
      {
        date: "8th , March 2023",
        date_name: "Wednesday ",
        slot: [
          {
            time: "01:40 PM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
          {
            time: "05:50 PM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
        ],
      },
      {
        date: "9th , March 2023",
        date_name: "Thursday ",
        slot: [
          {
            time: "01:40 PM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
          {
            time: "05:50 PM",
            hall: 2,
            hall_id: 17,
            hall_type: "Premium",
          },
        ],
      },
    ],
  },
];
